import jQuery from 'jquery';
import { debounce } from 'lodash-es';

let scrollToEnd = function (el) {
  var range = document.createRange();
  range.selectNodeContents(el);
  var sel = window.getSelection();
  sel.removeAllRanges();
  range.setStart(range.endContainer, range.endOffset);
  sel.addRange(range);

  // el.setSelectionRange(el.innerHTML.length, el.innerHTML.length)
};

let isSafari = function () {
  return /^((?!chrome|android|CriOS).)*safari/i.test(navigator.userAgent);
};

let isIOS = function () {
  if (typeof window === 'undefined') {
    return false;
  }

  return (
    ['iPad Simulator', 'iPhone Simulator', 'iPod Simulator', 'iPad', 'iPhone', 'iPod'].includes(navigator.platform) ||
    // iPad on iOS 13 detection
    (navigator.userAgent.includes('Mac') && 'ontouchend' in document)
  );
};

export const resizeEnd = (callback, debounceMs = 50) => {
  jQuery(window).resize(debounce(callback, debounceMs));
};

export const getTextElementLineHeight = (selector) => {
  const lineHeightToFontSizeRatio = 4 / 3;
  const fontSize = jQuery(selector).css('font-size');

  if (fontSize === undefined) {
    return undefined;
  }

  const lineHeight = Math.floor(parseInt(fontSize.replace('px', '')) * lineHeightToFontSizeRatio);
  return lineHeight;
};

export const getTextElementNumberOfLines = (selector) => {
  const lineHeight = getTextElementLineHeight(selector);
  const height = jQuery(selector).height();

  if (lineHeight === undefined || height === undefined) {
    return undefined;
  }

  return Math.round(height / lineHeight);
};

let scrollIntoViewPromise = function (el, options) {
  el.scrollIntoView(options);

  return {
    then: function (x) {
      const intersectionObserver = new IntersectionObserver((entries) => {
        let [entry] = entries;

        if (entry.isIntersecting) {
          setTimeout(() => {
            x();
            intersectionObserver.unobserve(el);
          }, 100);
        }
      });

      intersectionObserver.observe(el);
    },
  };
};

let scrollIntoViewWithinContainerPromise = function (el, container, options) {
  // Calculate the position of the element relative to the container
  const elTop = el.getBoundingClientRect().top;
  const containerTop = container.getBoundingClientRect().top;
  const offset = elTop - containerTop + container.scrollTop;

  if (options.behavior === 'smooth') {
    jQuery(container).animate(
      {
        scrollTop: '+=' + (offset - container.scrollTop),
      },
      500
    );
  } else {
    container.scrollTop = offset;
  }

  return new Promise((resolve) => {
    const intersectionObserver = new IntersectionObserver(
      (entries) => {
        let [entry] = entries;

        if (entry.isIntersecting) {
          setTimeout(() => {
            resolve();
            intersectionObserver.unobserve(el);
          }, 100);
        }
      },
      {
        root: container, // Set the root to the modal container
      }
    );

    intersectionObserver.observe(el);
  });
};

export default {
  goToElement(elem, options = {}) {
    let sel = getSelection().toString();

    if (!elem || sel != '') {
      return;
    }

    return scrollIntoViewPromise(elem, options);
  },

  goToElementWithinContainer(elem, container, options = {}) {
    return scrollIntoViewWithinContainerPromise(elem, container, options);
  },

  goToElementWithScroll(elem, options = {}) {
    let sel = getSelection().toString();
    let offsetTop = options.offsetTop || 0;

    if (!elem || sel != '') {
      return;
    }

    let findPos = function (obj) {
      var curtop = 0;
      if (obj.offsetParent) {
        do {
          curtop += obj.offsetTop;
        } while ((obj = obj.offsetParent));
        return curtop;
      }
    };

    let promise = new Promise((resolve, _reject) => {
      if (options.smooth) {
        window.scroll({
          top: findPos(elem) + offsetTop,
          behavior: 'smooth',
        });
      } else {
        window.scroll({
          top: findPos(elem) + offsetTop,
        });
      }
      resolve();
    });

    return promise;
  },

  focus: async function (node, focusAtFront = false) {
    node.focus();

    if (focusAtFront) {
      node.setSelectionRange(0, 0);
      node.scrollLeft = 0;
    }
  },

  focusAndScrollToEnd: async function (elem) {
    if (!elem) {
      return;
    }

    await this.focus(elem);
    scrollToEnd(elem);
  },

  focusAndHighlight: async function (elem) {
    if (!elem) {
      return;
    }

    await this.focus(elem);
  },

  waitForElement: function (element, maxIntervals = 5, intervalTime = 100) {
    let promise = new Promise((resolve, reject) => {
      var i = 0;
      var interval = setInterval(function () {
        let el = jQuery(element);
        i += 1;

        if (el.length > 0) {
          clearInterval(interval);
          resolve(el);
        }

        if (i > maxIntervals) {
          clearInterval(interval);
          reject();
        }
      }, intervalTime);
    });

    return promise;
  },

  emailIsValid: function (email, emptyIsValid = true) {
    email = email.trim().toLowerCase();

    const re =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    if (email === '' || email == null || email == undefined) {
      return emptyIsValid;
    } else {
      return !!re.test(email);
    }
  },

  textSelected() {
    return getSelection().toString().trim() !== '';
  },

  isSafari,
  isIOS,
  resizeEnd,
  getTextElementLineHeight,
  getTextElementNumberOfLines,
};
